<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#EDEDED"
            stroke-width="2"
            fill="none"
        />
        <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#007AFF"
            stroke-width="2"
            stroke-linecap="round"
            fill="none"
            stroke-dasharray="12 38"
        >
            <animate
                attributeName="stroke-dashoffset"
                from="0"
                to="-50"
                dur="1s"
                repeatCount="indefinite"
            />
        </circle>
    </svg>
</template>
